import {IForm} from '@/components/types'
import {useSearchDateShortcut} from '@/hooks/useSearch'

const shortcuts = useSearchDateShortcut()

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'timeSlot',
      type: 'dateTimePicker',
      label: '加入时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    },
    {
      field: 'deptId',
      type: 'select',
      label: '组别',
      clearable: true,
      filterable: true,
      placeholder: '请选择组别'
    },
    {
      field: 'empName',
      type: 'select',
      label: '员工',
      clearable: true,
      filterable: true,
      placeholder: '请选择员工'
    },
    {
      field: 'showSuccess',
      type: 'switch',
      label: '成交客户',
      activeValue: 1,
      inActiveValue: 0
    }
  ]
}
